import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["target", "required", "disabled", "children", "popoverIcon", "addon", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base, Text } from '../../Base';
var styles = {
  "root": "Label-root_3A7JB",
  "addon": "Label-addon_X3KSX",
  "popoverIcon": "Label-popoverIcon_eHEaM",
  "hasTarget": "Label-hasTarget_3hgAQ",
  "hasPopoverIcon": "Label-hasPopoverIcon_IsvXq",
  "required": "Label-required_2YMgy",
  "disabled": "Label-disabled_QMpUF"
};
function Label(_ref) {
  var _clsx;
  var target = _ref.target,
    required = _ref.required,
    disabled = _ref.disabled,
    children = _ref.children,
    popoverIcon = _ref.popoverIcon,
    addon = _ref.addon,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var hasPopoverIcon = /*#__PURE__*/React.isValidElement(popoverIcon);
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.required, required), _defineProperty(_clsx, styles.disabled, disabled), _defineProperty(_clsx, styles.hasTarget, target), _defineProperty(_clsx, styles.hasPopoverIcon, hasPopoverIcon), _clsx), className);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      flex: true,
      flexAlignItemsCenter: true,
      marginBottom: hasPopoverIcon ? null : 'xsmall',
      className: rootClasses
    }, extraProps), /*#__PURE__*/React.createElement(Base, {
      tagName: "label",
      htmlFor: target,
      weight: "regular"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "semibold"
    }, children), addon && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Text, {
      color: "light",
      weight: "regular",
      className: styles.addon
    }, addon))), popoverIcon && /*#__PURE__*/React.cloneElement(popoverIcon, {
      className: styles.popoverIcon
    }))
  );
}
export default Label;